// TeamData.js

const teamData = [
  {
    name: 'Gattu Durga Bhavani',
    rollNumber: '20VV1A1216',
    year: '2023-2024',
    linkedin: 'https://www.linkedin.com/in/gattu-durga-bhavani-1b1b1b1b1',
    github: 'https://github.com/gattudurgabhavani',
    instagram: 'https://instagram.com/gattudurgabhavani',
    website: '',
    email: 'gattudurgabhavani@example.com',
  },
  {
    name: 'Malla Naga Venkata Prasanth Naidu',
    rollNumber: '20VV1A1233',
    year: '2023-2024',
    linkedin: 'https://www.linkedin.com/in/malla-naga-venkata-prasanth-naidu-2c2c2c2c2',
    github: 'https://github.com/mallaprasanthnaidu',
    instagram: 'https://instagram.com/mallaprasanthnaidu',
    website: '',
    email: 'mallaprasanthnaidu@example.com',
  },
  {
    name: 'Nulu Prameela',
    rollNumber: '20VV1A1243',
    year: '2023-2024',
    linkedin: 'https://www.linkedin.com/in/nulu-prameela-3d3d3d3d3',
    github: 'https://github.com/nuluprameela',
    instagram: 'https://instagram.com/nuluprameela',
    website: '',
    email: 'nuluprameela@example.com',
  },
  {
    name: 'Robba Sangeetha',
    rollNumber: '20VV1A1255',
    year: '2023-2024',
    linkedin: 'https://www.linkedin.com/in/robba-sangeetha-4e4e4e4e4',
    github: 'https://github.com/robbasangeetha',
    instagram: 'https://instagram.com/robbasangeetha',
    website: '',
    email: 'robbasangeetha@example.com',
  },
];

export default teamData;

